module.exports = __webpack_public_path__ + "img/currency-guide-1.7c8c1382.png";